export default __webpack_public_path__ + "static/media/b_programas_sociales.cae4c3d9.jpg";